import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['flag', 'logos']

  mouseOver () {
    if (window.screen.width > 1000) {
      this.flagTarget.style.display = 'none'
      this.logosTarget.style.display = 'flex'
    }
  }

  mouseOut () {
    if (window.screen.width > 1000) {
      this.flagTarget.style.display = 'flex'
      this.logosTarget.style.display = 'none'
    }
  }
}
